import React, { useEffect, useState } from 'react';
import { API_BASE } from '../config/api';

const GestionEquipos = () => {
  const [colegios, setColegios] = useState([]);
  const [salas, setSalas] = useState([]);
  const [salaSeleccionada, setSalaSeleccionada] = useState('');
  const [nuevoEquipo, setNuevoEquipo] = useState('');
  const [equipos, setEquipos] = useState([]);

  // Modal + ficha técnica
  const [modalAbierto, setModalAbierto] = useState(false);
  const [equipoActual, setEquipoActual] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const [guardandoDetalle, setGuardandoDetalle] = useState(false);

  const [detalle, setDetalle] = useState({
    placa_madre_modelo: '',
    procesador_modelo: '',
    ram_gb: '',
    disco_tipo: '',
    disco_gb: '',
    tiene_teclado: 0,
    teclado_detalle: '',
    tiene_mouse: 0,
    mouse_detalle: '',
    cable_power_tipo: 'SIN_POWER', // ✅ nuevo (AMERICANO/BRASILERO/SCHUKO/SIN_POWER)
    // nuevo: selector directo de tipo (VGA/HDMI/NO en UI)
    cable_video_tipo_ui: 'NO', // 'VGA' | 'HDMI' | 'NO'
    monitor_marca: '',
    // monitor_pulgadas se deja en DB pero ya no se usa en UI
    observacion: '',
    fecha_verificacion: '' // "YYYY-MM-DDTHH:MM" desde input datetime-local
  });

  useEffect(() => {
    const cargarColegios = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/colegios`);
        if (!res.ok) throw new Error('No se pudo cargar colegios');
        const data = await res.json();
        setColegios(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error('Error cargando colegios:', e);
        setColegios([]);
      }
    };

    cargarColegios();
  }, []);

  useEffect(() => {
    const cargarEquipos = async () => {
      if (!salaSeleccionada) {
        setEquipos([]);
        return;
      }

      try {
        const res = await fetch(`${API_BASE}/api/salas/${salaSeleccionada}/equipos`);
        if (!res.ok) throw new Error('No se pudo cargar equipos');
        const data = await res.json();
        setEquipos(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error('Error cargando equipos:', e);
        setEquipos([]);
      }
    };

    cargarEquipos();
  }, [salaSeleccionada]);

  const obtenerSalas = async (colegioId) => {
    try {
      const res = await fetch(`${API_BASE}/api/colegios/${colegioId}/salas`);
      if (!res.ok) throw new Error('No se pudo cargar salas');
      const data = await res.json();
      setSalas(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('Error cargando salas:', e);
      setSalas([]);
    }
  };

  const manejarCambioColegio = (e) => {
    const id = e.target.value;
    if (id) obtenerSalas(id);
    else setSalas([]);
    setSalaSeleccionada('');
    setEquipos([]);
  };

  const agregarEquipo = async () => {
    if (!salaSeleccionada || !nuevoEquipo.trim()) return;

    try {
      const res = await fetch(`${API_BASE}/api/equipos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sala_id: salaSeleccionada, nombre: nuevoEquipo })
      });

      if (!res.ok) throw new Error('No se pudo agregar equipo');
      try { await res.json(); } catch {}

      setNuevoEquipo('');

      // recargar lista
      const resEquipos = await fetch(`${API_BASE}/api/salas/${salaSeleccionada}/equipos`);
      const dataEquipos = resEquipos.ok ? await resEquipos.json() : [];
      setEquipos(Array.isArray(dataEquipos) ? dataEquipos : []);
    } catch (e) {
      console.error('Error agregando equipo:', e);
      alert('No se pudo agregar el equipo');
    }
  };

  const eliminarEquipo = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar este equipo?')) return;

    try {
      const res = await fetch(`${API_BASE}/api/equipos/${id}`, {
        method: 'DELETE',
      });

      if (!res.ok) throw new Error('No se pudo eliminar equipo');
      try { await res.json(); } catch {}

      setEquipos((prev) => prev.filter((e) => e.id !== id));
    } catch (e) {
      console.error('Error eliminando equipo:', e);
      alert('No se pudo eliminar el equipo');
    }
  };

  const cambiarEstado = async (equipo) => {
    const nuevoEstado = equipo.activo === 1 ? 0 : 1;

    try {
      const res = await fetch(`${API_BASE}/api/equipos/${equipo.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nombre: equipo.nombre, activo: nuevoEstado })
      });

      if (!res.ok) throw new Error('No se pudo cambiar estado');
      try { await res.json(); } catch {}

      setEquipos((prev) => prev.map((e) => (e.id === equipo.id ? { ...e, activo: nuevoEstado } : e)));
    } catch (e) {
      console.error('Error cambiando estado:', e);
      alert('No se pudo actualizar el estado del equipo');
    }
  };

  // Helpers
  const toNumberOrNull = (v) => {
    if (v === '' || v === null || typeof v === 'undefined') return null;
    const n = Number(v);
    return Number.isNaN(n) ? null : n;
  };

  const datetimeLocalToMysql = (dtLocal) => {
    // "2026-01-14T10:30" -> "2026-01-14 10:30:00"
    if (!dtLocal) return null;
    const parts = dtLocal.split('T');
    if (parts.length !== 2) return null;
    return `${parts[0]} ${parts[1]}:00`;
  };

  const mysqlToDatetimeLocal = (dtMysql) => {
    // "2026-01-14 10:30:00" -> "2026-01-14T10:30"
    if (!dtMysql) return '';
    if (typeof dtMysql === 'string' && dtMysql.includes(' ')) {
      const [d, t] = dtMysql.split(' ');
      return `${d}T${t.slice(0, 5)}`;
    }
    try {
      const d = new Date(dtMysql);
      if (Number.isNaN(d.getTime())) return '';
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    } catch {
      return '';
    }
  };

  const setCampo = (campo, valor) => {
    setDetalle((prev) => ({ ...prev, [campo]: valor }));
  };

  const abrirModalFicha = async (equipo) => {
    setEquipoActual(equipo);
    setModalAbierto(true);
    setCargandoDetalle(true);

    // Reset para evitar que quede data anterior
    setDetalle({
      placa_madre_modelo: '',
      procesador_modelo: '',
      ram_gb: '',
      disco_tipo: '',
      disco_gb: '',
      tiene_teclado: 0,
      teclado_detalle: '',
      tiene_mouse: 0,
      mouse_detalle: '',
      cable_power_tipo: 'SIN_POWER', // ✅ nuevo
      cable_video_tipo_ui: 'NO',
      monitor_marca: '',
      observacion: '',
      fecha_verificacion: ''
    });

    try {
      const res = await fetch(`${API_BASE}/api/equipos/${equipo.id}/detalle`);
      const data = res.ok ? await res.json() : null;

      if (data) {
        // cable tipo desde BD (VGA/HDMI/NINGUNO) a UI (VGA/HDMI/NO)
        const cableBd = data.cable_video_tipo || null;
        const cableUi = cableBd === 'NINGUNO' || cableBd === null ? 'NO' : cableBd;

        // ✅ cable power tipo desde BD (AMERICANO/BRASILERO/SCHUKO/SIN_POWER)
        const powerBd = (data.cable_power_tipo || 'SIN_POWER').toString().toUpperCase();
        const powerUi =
          powerBd === 'AMERICANO' ||
          powerBd === 'BRASILERO' ||
          powerBd === 'SCHUKO' ||
          powerBd === 'SIN_POWER'
            ? powerBd
            : 'SIN_POWER';

        setDetalle({
          placa_madre_modelo: data.placa_madre_modelo || '',
          procesador_modelo: data.procesador_modelo || '',
          ram_gb: data.ram_gb ?? '',
          disco_tipo: data.disco_tipo || '',
          disco_gb: data.disco_gb ?? '',

          tiene_teclado: data.tiene_teclado ? 1 : 0,
          teclado_detalle: data.teclado_detalle || '',

          tiene_mouse: data.tiene_mouse ? 1 : 0,
          mouse_detalle: data.mouse_detalle || '',

          cable_power_tipo: powerUi, // ✅ nuevo

          cable_video_tipo_ui: cableUi,

          monitor_marca: data.monitor_marca || '',
          observacion: data.observacion || '',
          fecha_verificacion: mysqlToDatetimeLocal(data.fecha_verificacion)
        });
      }
    } catch (e) {
      console.error('Error al cargar detalle:', e);
      alert('No se pudo cargar la ficha técnica.');
    } finally {
      setCargandoDetalle(false);
    }
  };

  const cerrarModal = () => {
    if (guardandoDetalle) return;
    setModalAbierto(false);
    setEquipoActual(null);
  };

  const guardarFicha = async () => {
    if (!equipoActual) return;

    // Validaciones suaves
    if (detalle.disco_tipo && !['HDD', 'SSD'].includes(detalle.disco_tipo)) {
      alert('Tipo de disco inválido. Use HDD o SSD.');
      return;
    }

    // Teclado/mouse: si está en NO, limpiar detalle
    const tieneTeclado = Number(detalle.tiene_teclado) === 1 ? 1 : 0;
    const tieneMouse = Number(detalle.tiene_mouse) === 1 ? 1 : 0;

    // Cable de video UI -> BD
    const uiCable = (detalle.cable_video_tipo_ui || 'NO').toUpperCase();
    const bdCable = uiCable === 'NO' ? 'NINGUNO' : uiCable; // VGA/HDMI o NINGUNO

    if (!['VGA', 'HDMI', 'NINGUNO'].includes(bdCable)) {
      alert('Tipo de cable inválido. Use VGA, HDMI o NO.');
      return;
    }

    // mantenemos compatibilidad con columnas existentes
    const tieneCableVideo = bdCable === 'NINGUNO' ? 0 : 1;

    // ✅ cable power (validación simple)
    const power = (detalle.cable_power_tipo || 'SIN_POWER').toUpperCase();
    const powerFinal =
      power === 'AMERICANO' || power === 'BRASILERO' || power === 'SCHUKO' || power === 'SIN_POWER'
        ? power
        : 'SIN_POWER';

    setGuardandoDetalle(true);

    const payload = {
      placa_madre_modelo: detalle.placa_madre_modelo || null,
      procesador_modelo: detalle.procesador_modelo || null,
      ram_gb: toNumberOrNull(detalle.ram_gb),
      disco_tipo: detalle.disco_tipo || null,
      disco_gb: toNumberOrNull(detalle.disco_gb),

      tiene_teclado: tieneTeclado,
      teclado_detalle: tieneTeclado ? (detalle.teclado_detalle || null) : null,

      tiene_mouse: tieneMouse,
      mouse_detalle: tieneMouse ? (detalle.mouse_detalle || null) : null,

      // ✅ nuevo campo
      cable_power_tipo: powerFinal,

      // compatibilidad (aunque en UI ya no preguntamos)
      tiene_cable_video: tieneCableVideo,
      cable_video_tipo: bdCable,

      monitor_marca: detalle.monitor_marca || null,
      // monitor_pulgadas: ya no se envía
      observacion: detalle.observacion || null,
      fecha_verificacion: datetimeLocalToMysql(detalle.fecha_verificacion)
    };

    try {
      const res = await fetch(`${API_BASE}/api/equipos/${equipoActual.id}/detalle`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        console.error('Error guardando ficha:', data);
        alert(data?.mensaje || 'Error al guardar la ficha técnica.');
        return;
      }

      alert(data?.mensaje || 'Ficha técnica guardada correctamente.');
      cerrarModal();
    } catch (e) {
      console.error('Error guardando ficha:', e);
      alert('No se pudo guardar la ficha técnica.');
    } finally {
      setGuardandoDetalle(false);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-blue-700">Gestión de Equipos</h2>

      <div className="bg-white shadow p-4 rounded mb-6 space-y-4">
        <select onChange={manejarCambioColegio} className="w-full border px-3 py-2 rounded">
          <option value="">-- Seleccionar colegio --</option>
          {colegios.map((c) => (
            <option key={c.id} value={c.id}>{c.nombre}</option>
          ))}
        </select>

        <select
          value={salaSeleccionada}
          onChange={(e) => setSalaSeleccionada(e.target.value)}
          className="w-full border px-3 py-2 rounded"
        >
          <option value="">-- Seleccionar sala --</option>
          {salas.map((s) => (
            <option key={s.id} value={s.id}>
              {s.nombre} ({s.tipo})
            </option>
          ))}
        </select>

        <div className="flex gap-2">
          <input
            type="text"
            value={nuevoEquipo}
            onChange={(e) => setNuevoEquipo(e.target.value)}
            placeholder="Nombre del equipo"
            className="flex-1 border px-3 py-2 rounded"
          />
          <button onClick={agregarEquipo} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
            Agregar
          </button>
        </div>
      </div>

      <h3 className="text-lg font-semibold mb-2 text-gray-800">Equipos en esta sala</h3>
      <table className="w-full table-auto border-collapse bg-white shadow rounded-lg">
        <thead>
          <tr className="bg-blue-100 text-blue-900">
            <th className="px-4 py-2 border">Nombre</th>
            <th className="px-4 py-2 border">Activo</th>
            <th className="px-4 py-2 border">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {equipos.map((e) => (
            <tr key={e.id} className="text-center hover:bg-blue-50">
              <td className="px-4 py-2 border">{e.nombre}</td>
              <td className="px-4 py-2 border">{e.activo ? 'Sí' : 'No'}</td>
              <td className="px-4 py-2 border space-x-2">
                <button
                  onClick={() => abrirModalFicha(e)}
                  title="Ficha técnica"
                  className="px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                >
                  🧾
                </button>

                <button
                  onClick={() => cambiarEstado(e)}
                  title="Activar/Desactivar"
                  className="px-2 py-1 bg-yellow-500 text-white rounded hover:bg-yellow-600"
                >
                  🔄
                </button>

                <button
                  onClick={() => eliminarEquipo(e.id)}
                  title="Eliminar"
                  className="px-2 py-1 bg-red-600 text-white rounded hover:bg-red-700"
                >
                  🗑️
                </button>
              </td>
            </tr>
          ))}

          {equipos.length === 0 && (
            <tr>
              <td colSpan="3" className="px-4 py-6 text-center text-gray-500">
                Seleccioná un colegio y una sala para ver los equipos.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* MODAL FICHA TÉCNICA */}
      {modalAbierto && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 overflow-y-auto" onClick={cerrarModal}>
          <div className="min-h-screen w-full flex items-center justify-center p-4">
            <div
              className="w-full max-w-3xl bg-white rounded-xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header fijo */}
              <div className="flex items-center justify-between px-5 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white">
                <div>
                  <h3 className="text-lg font-bold">Ficha técnica</h3>
                  <p className="text-sm opacity-90">
                    Equipo: <span className="font-semibold">{equipoActual?.nombre}</span>
                  </p>
                </div>
                <button
                  onClick={cerrarModal}
                  className="bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-1 rounded"
                  title="Cerrar"
                >
                  ✕
                </button>
              </div>

              {/* Body con scroll */}
              <div className="flex-1 overflow-y-auto p-5">
                {cargandoDetalle ? (
                  <div className="text-center py-10 text-gray-600">Cargando ficha técnica...</div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Placa madre (modelo)</label>
                      <input
                        value={detalle.placa_madre_modelo}
                        onChange={(e) => setCampo('placa_madre_modelo', e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                        placeholder="Ej: ASUS PRIME H410M"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Procesador (modelo)</label>
                      <input
                        value={detalle.procesador_modelo}
                        onChange={(e) => setCampo('procesador_modelo', e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                        placeholder="Ej: Intel i5 10400"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">RAM (GB)</label>
                      <input
                        type="number"
                        value={detalle.ram_gb}
                        onChange={(e) => setCampo('ram_gb', e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                        placeholder="Ej: 8"
                        min="0"
                      />
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Disco (tipo)</label>
                        <select
                          value={detalle.disco_tipo}
                          onChange={(e) => setCampo('disco_tipo', e.target.value)}
                          className="w-full border px-3 py-2 rounded"
                        >
                          <option value="">-- Seleccionar --</option>
                          <option value="HDD">HDD</option>
                          <option value="SSD">SSD</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Disco (GB)</label>
                        <input
                          type="number"
                          value={detalle.disco_gb}
                          onChange={(e) => setCampo('disco_gb', e.target.value)}
                          className="w-full border px-3 py-2 rounded"
                          placeholder="Ej: 500"
                          min="0"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Teclado</label>
                      <select
                        value={detalle.tiene_teclado}
                        onChange={(e) => {
                          const v = Number(e.target.value);
                          setCampo('tiene_teclado', v);
                          if (v === 0) setCampo('teclado_detalle', '');
                        }}
                        className="w-full border px-3 py-2 rounded"
                      >
                        <option value={1}>Sí</option>
                        <option value={0}>No</option>
                      </select>

                      {Number(detalle.tiene_teclado) === 1 && (
                        <input
                          value={detalle.teclado_detalle}
                          onChange={(e) => setCampo('teclado_detalle', e.target.value)}
                          className="w-full border px-3 py-2 rounded mt-2"
                          placeholder="Marca y serie (ej: Logitech K120 - SN 12345)"
                        />
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Mouse</label>
                      <select
                        value={detalle.tiene_mouse}
                        onChange={(e) => {
                          const v = Number(e.target.value);
                          setCampo('tiene_mouse', v);
                          if (v === 0) setCampo('mouse_detalle', '');
                        }}
                        className="w-full border px-3 py-2 rounded"
                      >
                        <option value={1}>Sí</option>
                        <option value={0}>No</option>
                      </select>

                      {Number(detalle.tiene_mouse) === 1 && (
                        <input
                          value={detalle.mouse_detalle}
                          onChange={(e) => setCampo('mouse_detalle', e.target.value)}
                          className="w-full border px-3 py-2 rounded mt-2"
                          placeholder="Marca y serie (ej: Genius DX-110 - SN 77889)"
                        />
                      )}
                    </div>

                    {/* ✅ Cable power tipo */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Cable power</label>
                      <select
                        value={detalle.cable_power_tipo}
                        onChange={(e) => setCampo('cable_power_tipo', e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                      >
                        <option value="AMERICANO">Americano</option>
                        <option value="BRASILERO">Brasilero</option>
                        <option value="SCHUKO">Schuko</option>
                        <option value="SIN_POWER">Sin power</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Cable de video</label>
                      <select
                        value={detalle.cable_video_tipo_ui}
                        onChange={(e) => setCampo('cable_video_tipo_ui', e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                      >
                        <option value="NO">NO</option>
                        <option value="VGA">VGA</option>
                        <option value="HDMI">HDMI</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Monitor (marca)</label>
                      <input
                        value={detalle.monitor_marca}
                        onChange={(e) => setCampo('monitor_marca', e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                        placeholder="Ej: Samsung"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Observación</label>
                      <textarea
                        value={detalle.observacion}
                        onChange={(e) => setCampo('observacion', e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                        rows={3}
                        placeholder="Ej: falta un tornillo del gabinete, teclado con tecla dañada, etc."
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Fecha de verificación</label>
                      <input
                        type="datetime-local"
                        value={detalle.fecha_verificacion}
                        onChange={(e) => setCampo('fecha_verificacion', e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Esta fecha la cargás cuando el técnico verifica el equipo.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* Footer fijo con botones */}
              <div className="border-t bg-white px-5 py-4 flex items-center justify-end gap-2">
                <button
                  onClick={cerrarModal}
                  disabled={guardandoDetalle}
                  className="px-4 py-2 rounded border hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button
                  onClick={guardarFicha}
                  disabled={guardandoDetalle}
                  className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                >
                  {guardandoDetalle ? 'Guardando...' : 'Guardar ficha'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestionEquipos;